module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAAeFBMVEUAAABAQEBBQUFBQUFBQUFBQUE/Pz88PDw2NjZAQEBAQEBAQEBAQEAkJCRBQUFAQEBAQEBAQEBAQEA/Pz9BQUFAQEBAQEBAQEBAQEBCQkI+Pj5AQEBAQEBAQUFAQEBBQUFAQEBAQEBAQEBAQEBAQEA/Pz8/Pz9BQUGfnEsRAAAAJ3RSTlMA3fz59ckrDwru4VIjB9jQo41mQuV+eFhIOjMgFue7tayXcGxfSTiPtEj+AAAApUlEQVQY01WOVw6DMBBElw7GppcA6W3uf8MMcWwp78MePe2sVr70tySom9KII01gqfqfOcRwhJ2doYnbXi9jQfcSwpZKZefIOOSscYbGugG4izRAK44OSEQC4O1VFiI0EgG5eBSw7cqIhx29P6s3eYQw/1//BGqREoi1287KxL8Gqs2aM1BkDGvEMKaZfigAMw2rdI5JLEsFy6kUh5mvQaEunb35A71XEeo48rsuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contentLeftIcon.png
// module id = msHI
// module chunks = 2